import { Link } from "react-router-dom";
import { isAdmin } from "../../../../../../../utils";
import styles from "./card-subtitle.module.scss";

const isAdminUser = isAdmin();

const REROUTE_LOCATION = {
  TI_CLOUD: "/config/",
  INTEGRATION: "/integrations/"
};

export type Type = "TI_CLOUD" | "INTEGRATION";

type Props = {
  type: Type;
};

const Configure = ({ type }: Props) =>
  isAdminUser ? (
    <Link
      to={REROUTE_LOCATION[type]}
      reloadDocument
      className={styles.link}
      data-testid="report_summary_subheader_configure_link"
    >
      Not Configured
    </Link>
  ) : (
    <span className={styles.font_size}>Not Configured</span>
  );

export default Configure;
